var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticky-button"},[_c('router-link',{attrs:{"to":"/qrscanner"}},[_c('button',{staticClass:"btn btn-info",attrs:{"href":"#scan"}},[_c('span',{staticClass:"glyphicon glyphicon-qrcode"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }